import styled from 'styled-components'

import { Colors } from '~/styles'

const LegendContainer = styled.section`
  left: 0;
  width: 100%;
  bottom: 0;
  padding: 16px 24px;
  position: fixed;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  background-color: ${Colors.backgroundColor};
`

const ListLegendGroup = styled.ul`
  gap: 40px;
  margin: 0;
  padding: 0;
  display: flex;
  list-style: none;
  align-items: center;
`

const ListLegendItem = styled.li`
  gap: 8px;
  color: ${Colors.cancelTextColor};
  display: flex;
  font-size: 14px;
  font-weight: 500;
  align-items: center;
`

const LegendColorBox = styled.span`
  width: 28px;
  height: 28px;
  display: inline-block;
  border-radius: 50%;
  background-color: ${(props) => props.color || Colors.cancelTextColor};
`

export default {
  LegendColorBox,
  ListLegendItem,
  ListLegendGroup,
  LegendContainer,
}